import {getAboutText} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {isEditor, isMobile} from '../../../../../../commons/selectors/environment'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {isPaidPlansVisible} from '../../../selectors/paid-plans'
import {isGroupActivityVisible} from '../../../selectors/groups'
import {AboutSection as Presentation} from './about-section'
import {AboutSectionOwnProps, AboutSectionRuntimeProps} from './interfaces'

export const mapRuntimeToProps = ({state, host}: DetailsPageAppProps): AboutSectionRuntimeProps => ({
  updateLayout: host.updateLayout,
  aboutText: getAboutText(state.event),
  isEditor: isEditor(state),
  isMobile: isMobile(state),
  readMoreButtonExtraMargin: isPaidPlansVisible(state) && !isGroupActivityVisible(state),
  readMoreButtonVisible: state.component.settings.readMoreButtonVisible,
  eventId: state.event.id,
})

export const AboutSection = withTranslation()(
  connect<AboutSectionOwnProps, AboutSectionRuntimeProps>(mapRuntimeToProps)(Presentation),
)
export * from './interfaces'
